import {useContext} from "react";
import {UserContext, UserContextType} from "../context/UserContext";


export function useUserInfo() : UserContextType {
    return useContext(UserContext);
}
